import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getSite = async () => (await axios.get(`${API}/site`)).data;

export const getRecaps = async () => (await axios.get(`${API}/recaps`)).data;

export const addRecap = async (payload) =>
  (await axios.post(`${API}/recaps`, payload)).data;

export const updateCountdowns = async (payload) =>
  (await axios.put(`${API}/site/countdowns`, payload)).data;

export const getGames = async () => (await axios.get(`${API}/games`)).data;

export const addGame = async (payload) =>
  (await axios.post(`${API}/games`, payload)).data;

export const updateRecap = async (id, payload) =>
  (await axios.put(`${API}/recaps/${id}`, payload)).data;

export const deleteRecap = async (id, passcode) =>
  (await axios.delete(`${API}/recaps/${id}`, { params: { passcode } })).data;

export const scrollToSection = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
